import React from 'react'
import SideLogo from '../../Images/TopbarImg/Logo.png'
import Aos from 'aos'

const SadasyaSamman = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='aboutus-body'>
                    <div className='aboutus-left' data-aos='fade-right'>
                        <img src={SideLogo} alt='Kanaklaxmi-Logo' />
                    </div>
                    <div className='aboutus-right'>
                        <div className='heading1' data-aos='fade-right'>
                            <div className='h2'>
                                <h2>सदस्य सम्मान / पुरस्कार कार्यक्रम</h2><hr />
                            </div>
                        </div>
                        <div className='samman-detail' data-aos='fade-right'>
                            <ul>
                                <li>१. जेष्ठ सदस्य सम्मान</li>
                                <li>२. असल ऋण कारोबार पुरस्कार</li>
                                <li>३. उत्कृष्ट रेमिट कारोबार पुरस्कार</li>
                                <li>४. उत्कृष्ट बचत कर्ता पुरस्कार</li>
                                <li>५. उत्कृष्ट बाल बचत कर्ता पुरस्कार</li>
                                <li>६. अधिक संरक्षित पुंजि फिर्ता कोष प्राप्त गर्ने सदस्य पुरस्कार</li>
                                <li>७. उत्कृष्ट लघु वित्त समुह पुरस्कार</li>
                                <li>८. विद्या वरिधि गर्ने सेयर सदस्य सम्मान</li>
                                <li>९. सहकारी अभियान्त सम्मान </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default SadasyaSamman